import { render, staticRenderFns } from "./OrderPartnerEditLots.vue?vue&type=template&id=cb466cea&scoped=true&"
import script from "./OrderPartnerEditLots.vue?vue&type=script&lang=js&"
export * from "./OrderPartnerEditLots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb466cea",
  null
  
)

export default component.exports